import { render } from "./TextGrid.vue?vue&type=template&id=3e46fbce"
import script from "./TextGrid.vue?vue&type=script&lang=js"
export * from "./TextGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__